<template>
  <div class="auto_1280">
    <div class="profile">
      <div v-for="( item, index ) in content" :key="index" class="clearfix">
        <div class="fl">
          <div class="tit1">{{item.title}}</div>
          <div class="txt1">{{item.content}}</div>
          <div class="qrcode" v-if="item.intro">
            <img :src="item.intro" alt="">
            <pre v-if="lan === 0">{{text}}</pre>
            <pre v-else-if="lan === 1">{{enText}}</pre>
          </div>
        </div>
        <div class="fr"><img :src="item.coverImg"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OrganizationProfile',
  data () {
    return {
      articleTypeId: 16,
      content: [],
      lan: this.$store.state.isEn,
      text: '扫二维码\n了解更多',
      enText: 'Scan QR code\nLearn more'
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
    const self = this
    self.initId()
    self.init()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      this.content = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: 16, current: 1, pageSize: 10, bLanguage: this.lan }, r => {
        const content = []
        r.data.forEach((item) => {
          item.content = decodeURIComponent(item.content)
          content.push(item)
        })
        this.content = content
      })
    }
  }
}
</script>
<style>
.profile{padding: 2% 0 5%; position: relative; z-index: -1;}
.profile .title{font-size: 40px; color: #e4007f; padding-bottom: 4%;}
.profile .txt{color: #222; line-height: 2; text-align: justify;}
.profile .txt.en{padding-right: 65%;}
.profile .part1{position: relative; padding-bottom: 5%;}
.profile .part1 .pic{position: absolute; top: 0; right: 0; z-index: -1; max-width: 750px; width: 58%;}
.profile .content-box{padding-top: 9%;}
.profile .content-box pre{display: inline-block; margin-right: 7.8125%; font-weight: lighter; color: #222; padding-top: 80px;}
.profile .content-box pre em{font-size: 30px; color: #e4007f; padding: 0 3px; font-style: normal;}
.profile .content-box pre:first-child{background: url(../../assets/profile-icon1.png)no-repeat left top;}
.profile .content-box pre:nth-child(2){background: url(../../assets/profile-icon2.png)no-repeat left top;}
.profile .content-box pre:last-child{background: url(../../assets/profile-icon3.png)no-repeat left top;}

.profile .part2{padding: 5% 0;}
.profile .tit{font-size: 30px; color: #333; letter-spacing: 1px; padding-bottom: 2%;}
.profile .tit em{font-size: 16px; color: #999; font-weight: lighter; font-style: normal;}
.profile .part2 li{width: 33.3333%; float: left; text-align: center; padding: 3% 0; min-height: 240px;
background: -moz-linear-gradient(left, rgba(228,0,127,0.1) 0%, rgba(228,0,127,.01) 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(left, rgba(228,0,127,0.1) 0%,rgba(228,0,127,.01) 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to right, rgba(228,0,127,0.1) 0%,rgba(228,0,127,.01) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}
.profile .subtit{font-size: 24px; color: #e4007f;}
.profile .part2 li pre{text-align: center; padding-top: 3%; line-height: 2;}
.profile .part2 li pre em{color: #e4007f; font-size: 22px; font-style: normal;}
.profile .part2 .en li{min-height: 275px;}

.profile .part3{padding-top: 5%;}
.profile .part3 li{width: 50%; padding-left: 140px; background: url(../../assets/profil-icon.png)no-repeat left top; float: left;}
.profile .part3 .txt{padding-right: 11%; padding-top: 3%;}
.profile .part3 .pic{text-align: center; margin: 4% 0; border: 1px solid rgba(228,0,127,0.1);}

.profile .pic{width: 100%; padding-bottom: 5%;}
.profile .pic img{width: 100%; height: auto!important;}
@media(max-width: 1200px){
  .profile .title{font-size: 38px;}
}
@media(max-width: 1024px){
  .profile .part2 li{width: 50%; margin-bottom: 2%;}
}
@media(max-width: 960px){
  .profile .part2 li{width: 100%; min-height: 0; padding: 4% 0;}
  .profile .part3 li{width: 100%; margin-bottom: 4%;}
  .profile .txt{padding-right: 0;}
  .profile .part3 .txt{padding-top: 2%;}
  .profile .part1 .pic{position: initial; width: 100%; padding-top: 3%;}
  .profile .content-box{padding: 4% 0;}
  .profile .content-box pre{margin: 3% 7% 3% 0;}
}
@media(max-width: 480px){
  .profile .part3 li{background-size: 90px; padding-left: 100px;}
}

.profile .fl,
.profile .fr{width: 50%; float: left;}
.profile .fl{padding-right: 5%;}
.profile .fr img{width: 100%; height: auto;}
.profile .tit1{font-size: 48px; color: #e4007f; padding-bottom: 5%;}
.profile .txt1{white-space: pre-wrap; color: #222; line-height: 2; padding: 3% 0 6% 0; font-size: 20px;}
.profile .qrcode pre{display: inline-block; vertical-align: middle; padding-left: 5%; line-height: 1.8; font-size: 14px; color: #666; font-weight: lighter;}
.profile .qrcode img{border: 1px solid #ebebeb;}
@media(max-width: 960px){
  .profile .tit1{font-size: 36px;}
}
@media(max-width: 768px){
  .profile .fl,
  .profile .fr{width: 100%; float: none;}
  .profile .fl{padding-right: 0;}
  .profile .fr{padding-right: 0;}
  .profile .fr{padding-top: 5%;}
  .profile .txt1{padding: 2% 0 4% 0;}
}
@media(max-width: 640px){
  .profile .tit1{font-size: 28px;}
  .profile .qrcode img{max-width: 110px;}
}
</style>
